// extracted by mini-css-extract-plugin
export default {"App":"Wrapper_App__BQaYf"};